import React, { useEffect, useState } from "react";
import { FullViewTableCard } from "../components/cards";
import Row from "../components/general/row";
import Column from "../components/general/column";
import { getClientByNetwork } from "../api/clients-api";
import { formatCurrency, formatDateTime } from "../utils.js";
import TabGroup from "../components/general/TabGroup";
import {
  Eye,
  EyeOff,
  LoaderCircle,
} from "lucide-react";
import Modal from "../components/general/modal";
import { Form } from "../components/general/form";
import { Toaster, toast } from "react-hot-toast";
import { useAuth } from "../context/authContext";
import { payment_axi, axi } from "../context/authContext";
import { useNavigate } from "react-router-dom";

const formatTransactionType = (value) => {
  if (!value) return "-";

  return value
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

const formatWalletBalance = (walletAccount) => {
  const rawBalance =
    walletAccount?.balance_naira ??
    walletAccount?.balance ??
    walletAccount?.balance_display;
  const numericBalance = Number(String(rawBalance ?? 0).replace(/,/g, ""));

  return formatCurrency(Number.isNaN(numericBalance) ? 0 : numericBalance);
};

const Dashboard = () => {
  const {user, NETWORK} = useAuth();
  const navigate = useNavigate();
  // Previous implementation kept for reference:
  // const [dataLoading, setDataLoading] = useState(false);
  const [withdrawalFormLoading, setWithdrawalFormLoading] = useState(false);
  const [isWithdrawalModalOpen, setIsWithdrawalModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  // Previous implementation kept for reference:
  // const [withdrawalRequests, setWithdrawalRequests] = useState([]);
  const [accountStatement, setAccountStatement] = useState([]);
  const [client, setClient] = useState();
  const [walletAccount, setWalletAccount] = useState();
  const [walletAccountLoading, setWalletAccountLoading] = useState(false);
  const [errors, setErrors] = useState();
  const [visible, setVisible] = useState(false);
  // Previous implementation kept for reference:
  // const [powerSales, setPowerSales] = useState([]);
  // const [billPayments, setBillPayments] = useState([]);
  // const [powerSalestableLoading, setPowerSalestableLoading] = useState(false);
  // const [billPaymentsTableLoading, setBillPaymentsTableLoading] = useState(false);
  const [statementLoading, setStatementLoading] = useState(false);
  const [statementInitialized, setStatementInitialized] = useState(false);
  // const [balanceAudits, setBalanceAudits] = useState([]);
  // const [balanceAuditsLoading, setBalanceAuditsLoading] = useState(false);

  let loadingToastId = null;

  const fetchWalletAccount = async (clientId) => {
    try {
      setWalletAccountLoading(true);
      const response = await payment_axi.get(`/api/accounts/get-account-by-client-id/${clientId}`);
      setWalletAccount(response?.data);
    } catch (error) {
      console.error("Error fetching wallet account:", error);
    } finally {
      setWalletAccountLoading(false);
    }
  };

  const fetchAccountStatement = async (accountId) => {
    try {
      setStatementLoading(true);
      const response = await payment_axi.get(`/api/account-reports/get-account-statement/${accountId}`);
      response?.data ? setAccountStatement(response.data) : setAccountStatement([]);
    } catch (error) {
      console.error("Error fetching account statement:", error);
    } finally {
      setStatementInitialized(true);
      setStatementLoading(false);
    }
  };

  const fetchProfileData = async (network) => {
    try {
      // Previous implementation kept for reference:
      // setDataLoading(true);
      const response = await getClientByNetwork(network);
      setClient(response.data);
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
    // Previous implementation kept for reference:
    // finally {
    //   setDataLoading(false);
    // }
  };

  useEffect(() => {
    if (user) fetchProfileData(NETWORK);
  }, [user, NETWORK]);

  useEffect(() => {
    if (client?.client_id) {
      fetchWalletAccount(client.client_id);
    }
  }, [client?.client_id]);

  // Previous implementation kept for reference:
  // useEffect(() => {
  //   const fetchWithdrawalRequests = async (network) => {
  //     try {
  //       setDataLoading(true);
  //       const response = await payment_axi.get(`/api/payments/withdrawals-request-by-network?network=${network}`);
  //       response.data ? setWithdrawalRequests(response.data) : setWithdrawalRequests([]);
  //     } catch (error) {
  //       console.error("Error fetching withdrawal requests:", error);
  //     } finally {
  //       setDataLoading(false);
  //     }
  //   };
  //   fetchWithdrawalRequests(NETWORK);
  // }, [user]);

  useEffect(() => {
    if (walletAccount?.id) {
      fetchAccountStatement(walletAccount.id);
    }
  }, [walletAccount?.id]);

  // Previous implementation kept for reference:
  // useEffect(() => {
  //   setPowerSalestableLoading(true);
  //   const fetchPowerSalesData = async () => {
  //     try {
  //       const response = await fetchPowerSales(NETWORK);
  //       setPowerSales(response?.data);
  //     } catch (error) {
  //       console.error("Error fetching power sales:", error);
  //     } finally {
  //       setPowerSalestableLoading(false);
  //     }
  //   };
  //   fetchPowerSalesData();
  // }, [user]);

  // Previous implementation kept for reference:
  // useEffect(() => {
  //   setBillPaymentsTableLoading(true);
  //   const fetchBillPaymentsData = async () => {
  //     try {
  //       const response = await fetchBillPayments(NETWORK);
  //       setBillPayments(response?.data);
  //     } catch (error) {
  //       console.error("Error fetching bills payment:", error);
  //     } finally {
  //       setBillPaymentsTableLoading(false);
  //     }
  //   };
  //   fetchBillPaymentsData();
  // }, [user]);

  // useEffect(() => {
  //   setBalanceAuditsLoading(true);
  //   const fetchBalanceAuditData = async () => {
  //     try {
  //       // category required by the API
  //       const response = await fetchBalanceAuditTrails("central-balance-audit");
  //       const items = response?.data || [];
  //
  //       const filtered = items?.filter((t) => {
  //         const trailNetwork = (t?.network || "").toString().toLowerCase();
  //         const currentNetwork = (NETWORK || "").toString().toLowerCase();
  //         return trailNetwork === currentNetwork;
  //       });
  //       setBalanceAudits(filtered);
  //     } catch (error) {
  //       console.error("Error fetching balance audit trails:", error);
  //     } finally {
  //       setBalanceAuditsLoading(false);
  //     }
  //   };
  //
  //   if (user && NETWORK) fetchBalanceAuditData();
  // }, [user, NETWORK]);

  const auditColumns = [
    "Reference",
    "Amount",
    "Transaction Type",
    "Status",
    "Transaction Date",
  ];

  // Previous implementation kept for reference:
  // const powerSalesTableData = powerSales
  // ?.filter(trail => trail?.TransactionType === "CR")
  // .map(trail => ({
  //   "Full Name": trail?.FullName,
  //   "Email": trail?.Email,
  //   "Amount": formatCurrency(trail?.Amount),
  //   "Power Unit": trail?.power_unit + " kWh",
  //   "Balance Before": formatCurrency(trail?.BalanceBefore),
  //   "Balance After": formatCurrency(trail?.BalanceAfter),
  //   "Payment Gateway": trail?.PaymentGateway,
  //   "Transaction Date": formatDateTime(trail?.TransactionDate),
  // }));
  const powerSalesTableData = (accountStatement || [])
    .filter((entry) => entry?.transaction_type === "internal_power_purchase" && entry?.transaction_status === "success")
    .map((entry) => ({
      "Reference": entry?.reference || "-",
      "Amount": formatCurrency(entry?.amount),
      "Transaction Type": formatTransactionType(entry?.transaction_type),
      "Status": entry?.transaction_status || "-",
      "Transaction Date": formatDateTime(entry?.created_at),
    }));

  // Previous implementation kept for reference:
  // const billPaymentsTableData = billPayments
  // ?.filter(trail => trail?.TransactionType === "CR")
  // ?.map(trail => ({
  //   "Full Name": trail?.FullName,
  //   "Email": trail?.Email,
  //   "Amount": formatCurrency(trail?.Amount),
  //   "Power Unit": trail?.power_unit + " kWh",
  //   "Balance Before": formatCurrency(trail?.BalanceBefore),
  //   "Balance After": formatCurrency(trail?.BalanceAfter),
  //   "Payment Gateway": trail?.PaymentGateway,
  //   "Transaction Date": formatDateTime(trail?.TransactionDate),
  // }));
  const billPaymentsTableData = (accountStatement || [])
    .filter((entry) => entry?.transaction_type === "bill_payment" && entry?.transaction_status === "success")
    .map((entry) => ({
      "Reference": entry?.reference || "-",
      "Amount": formatCurrency(entry?.amount),
      "Transaction Type": formatTransactionType(entry?.transaction_type),
      "Status": entry?.transaction_status || "-",
      "Transaction Date": formatDateTime(entry?.created_at),
    }));

  // const balanceAuditColumns = [
  //   "Email",
  //   "Message",
  //   "Date",
  // ];
  //
  // const balanceAuditTableData = (balanceAudits || [])
  //   // defensive filter in case some items slipped through or have different casing
  //   ?.filter((trail) => ((trail?.network || "") + "").toLowerCase() === ((NETWORK || "") + "").toLowerCase())
  //   ?.map((trail) => {
  //     const emailVal = trail?.email || "";
  //     const dateVal = trail?.dateTime || trail?.date || trail?.TransactionDate;
  //     const messageVal = trail?.message || trail?.Narration || "";
  //
  //     return {
  //       "Email": emailVal,
  //       "Message": messageVal,
  //       "Date": formatDateTime(dateVal),
  //     };
  //   });


  const handleWithdrawal = async () => {
    setErrors("");
    try {
      setWithdrawalFormLoading(true);
      const payload = {
        client_id: client?.client_id,
        amount: parseFloat(formData.amount),
        description: formData.remark || "",
      };

      if (!payload.client_id) {
        throw new Error("Client ID is required to initiate withdrawal.");
      }

      if (!loadingToastId) {
        loadingToastId = toast.loading("Loading...");
      }
      // const response = await payment_axi.post("/api/payments/request-withdrawal", payload);
      const response = await payment_axi.post("/api/accounting/initiate-withdrawal", payload);
      if (response.status !== 200 && response.status !== 201) {
        toast.dismiss(loadingToastId);
        toast.error("There was an error creating request", { duration: 10000 });
      } else {
        toast.dismiss(loadingToastId);
        toast.success("Request created successfully", { duration: 10000 });
        setWithdrawalFormLoading(false);
        setIsWithdrawalModalOpen(false);
        setFormData({});

        if (client?.client_id) {
          fetchWalletAccount(client.client_id);
        }
        if (walletAccount?.id) {
          fetchAccountStatement(walletAccount.id);
        }

        // Send withdrawal request notification
        axi.post("/api/v1/admin-alerts/notify", {
            listName: "Withdrawal-notification",
            actionType: "WITHDRAWAL_REQUEST",
            actor: user?.email || "",
            details: {
              Amount: formatCurrency(formData.amount),
              Remark: formData.remark || "",
            }
          }).catch((notificationError) => {
          // Log error but don't show to user since withdrawal request was successful
          console.error("Error sending withdrawal request notification:", notificationError);
        });
        return;
      }
    } catch (error) {
      if (error?.response?.status === 403) {
        toast.dismiss(loadingToastId);
        console.log(error?.response?.data?.error);
        toast.error(error?.response?.data?.error, { duration: 10000 });
        return;
      }
      toast.dismiss(loadingToastId);
      const errorMessage = error?.response?.data || error?.message || "An unexpected error occurred.";
      setErrors(errorMessage);
      toast.error(errorMessage, {duration: 10000});
    } finally {
      setWithdrawalFormLoading(false);
    }
  };


  // Previous implementation kept for reference:
  // const withdrawalHistoryTableData = withdrawalRequests
  // .slice()
  // .filter(request => request.status === "Completed")
  // .map(request => ({
  //   Amount: formatCurrency(request.amount),
  //   Remark: request.remark,
  //   Status: request.status &&
  //   <div className="flex items-center gap-2">
  //     <span className="inline-block rounded-full h-3 w-3 bg-primary-success"></span>
  //     <span className="text-sm">
  //       Completed
  //     </span>
  //   </div>,
  //   "Requested on": formatDateTime(request.requestDateTime),
  //   "Updated on": formatDateTime(request.lastUpdated),
  // }));
  const withdrawalHistoryTableData = (accountStatement || [])
  .slice()
  .filter((entry) => entry?.transaction_type === "withdrawal" && entry?.transaction_status === "success")
  .map((entry) => ({
    Amount: formatCurrency(entry?.amount),
    Remark: entry?.description || "-",
    Reference: entry?.reference || "-",
    Status: entry?.transaction_status && 
    <div className="flex items-center gap-2">
      <span className="inline-block rounded-full h-3 w-3 bg-primary-success"></span>
      <span className="text-sm">
        Completed
      </span>
    </div>,
    "Requested on": formatDateTime(entry?.created_at),
    "Updated on": "-",
  }));


  // Previous implementation kept for reference:
  // const pendingWithdrawalsTableData = withdrawalRequests
  //   .slice()
  //   .filter(request => request.status === "Pending" || request.status === "Processing")
  //   .map(request => ({
  //     Amount: formatCurrency(request.amount),
  //     Remark: request.remark,
  //     Status: (
  //       <div className="flex items-center gap-2">
  //         <span
  //           className={`inline-block rounded-full h-3 w-3 ${
  //             request.status === "Pending" ? "bg-primary-gray" : "bg-primary-warning"
  //           }`}
  //         ></span>
  //         <span className="text-sm">
  //           {request.status === "Pending" ? "Pending"  : request.status === "Processing" ? "Processing" : "Unknown"}
  //         </span>
  //       </div>
  //     ),
  //     "Requested on": formatDateTime(request.requestDateTime),
  //     "Updated on":
  //       new Date(request.requestDateTime) > new Date(request.lastUpdated)
  //         ? "-"
  //         : formatDateTime(request.lastUpdated),
  //   }));
  const pendingWithdrawalsTableData = (accountStatement || [])
    .slice()
    .filter((entry) => entry?.transaction_type === "withdrawal" && entry?.transaction_status === "pending")
    .map((entry) => ({
      Amount: formatCurrency(entry?.amount),
      Reference: entry?.reference || "-",
      Remark: entry?.description || "-",
      Status: (
        <div className="flex items-center gap-2">
          <span
            className="inline-block rounded-full h-3 w-3 bg-primary-gray"
          ></span>
          <span className="text-sm">
            Pending
          </span>
        </div>
      ),
      "Requested on": formatDateTime(entry?.created_at),
      "Updated on": "-",
    }));

  const pendingWithdrawalsColumns = ["Reference", "Amount", "Remark", "Status", "Requested on"];
  const withdrawalHistoryColumns = ["Reference", "Amount", "Remark", "Status", "Requested on"];
  const shouldShowStatementLoading =
    statementLoading || (!statementInitialized && (walletAccountLoading || !walletAccount?.id));

  const handleViewStatement = () => {
    navigate("/dashboard/statement");
  };

  const tabs = [
    { label: "Pending withdrawals", content: <FullViewTableCard title={"Pending Withdrawals"} data={pendingWithdrawalsTableData} columns={pendingWithdrawalsColumns} loading={shouldShowStatementLoading} /> },
    { label: "Withdrawal history", content: <FullViewTableCard title={"Withdrawal History"} data={withdrawalHistoryTableData} columns={withdrawalHistoryColumns} loading={shouldShowStatementLoading} /> },
    { label: "Power Sales", content: <FullViewTableCard title={"Power Sales"} data={powerSalesTableData} columns={auditColumns} loading={shouldShowStatementLoading} /> },
    { label: "Bill Payment", content: <FullViewTableCard title={"Bill Payment"} data={billPaymentsTableData} columns={auditColumns} loading={shouldShowStatementLoading} /> },
  ];

  const withdrawalFormFields = [
    { type: "number", name: "amount", label: "Amount", placeholder: "Enter amount", value: formData.amount, required: true },
    { type: "textarea", name: "remark", label: "Remark", placeholder: "Enter remark", value: formData.remark, required: true },
  ];
  return (
    <Column>
      <Row>
        <div className="relative flex flex-col text-white p-6 rounded-2xl shadow-md shadow-primary-dark/50 w-full max-w-lg overflow-hidden font-nexa
          bg-card-bg bg-cover bg-no-repeat my-3">
          <div className="flex items-center justify-between mb-6">
            <div className="w-10 h-10 rounded-sm shadow-inner bg-nano-logo-icon-white bg-cover"></div>
            <p className="text-sm uppercase tracking-widest font-semibold text-white/70">NanoWattz</p>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-white/70">Central Balance</p>
              {/* Previous implementation kept for reference:
              <p className="text-3xl font-bold text-white mt-1 transition-all duration-300">
                {visible ? (client?.central_balance !== null ? formatCurrency(client?.central_balance) : formatCurrency(0)) : "*********"}
              </p>
              */}
              {visible ? (
                walletAccountLoading ? (
                  <div className="mt-2 flex items-center">
                    <LoaderCircle size={28} className="animate-spin text-white/85" />
                  </div>
                ) : (
                  <p className="text-3xl font-bold text-white mt-1 transition-all duration-300">
                    {formatWalletBalance(walletAccount)}
                  </p>
                )
              ) : (
                <p className="text-3xl font-bold text-white mt-1 transition-all duration-300">
                  *********
                </p>
              )}
            </div>
            <button
              onClick={() => setVisible(!visible)}
              className="text-white hover:text-gray-300 transition"
              aria-label="Toggle Balance Visibility"
            >
              {visible ? <EyeOff size={24} /> : <Eye size={24} />}
            </button>
          </div>

          <div className="mt-6 pt-4 border-t border-white/20 flex gap-3">
            <button
              className="w-full py-2 bg-white/10 hover:bg-white/20 text-white rounded-lg shadow-md transition font-medium"
              onClick={() => {setErrors(""); setIsWithdrawalModalOpen(true)}}
              disabled={walletAccountLoading || Number(walletAccount?.balance_naira || 0) <= 0}
            >
              Withdraw
            </button>
            <button
              className="w-full py-2 border border-white/30 bg-transparent hover:bg-white/10 text-white rounded-lg shadow-md transition font-medium"
              onClick={handleViewStatement}
            >
              View statement
            </button>
          </div>
        </div>
      </Row>
      <Row>
        <TabGroup tabs={tabs} />
      </Row>
      <Toaster position="top-center" />
      <Modal isOpen={isWithdrawalModalOpen} onClose={() => setIsWithdrawalModalOpen(false)} title="Withdraw funds">
        {formData.amount && parseFloat(formData.amount || 0) > parseFloat(walletAccount?.balance_naira || 0) && (
          <p className="text-error font-nexa text-md mb-4 bg-red-500/10 p-2 rounded-md">Insufficient Funds</p>
        )}
        {errors && <p className="text-error font-nexa text-md">{errors}</p>}
        <Form
          fields={withdrawalFormFields}
          onSubmit={handleWithdrawal}
          formData={formData}
          setFormData={setFormData}
          btnText="Request withdrawal"
          isLoading={withdrawalFormLoading}
          beforeSubmit={
            <div className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2.5 text-amber-900">
              <p className="mb-1 text-sm font-bold leading-5">
                Withdrawals are processed on the next business working day
                after initiation.
              </p>
              <p className="mb-0 border-l-2 border-amber-300 pl-2 text-xs leading-5 text-amber-800">
                Monday to Thursday requests are processed the following business
                day. Friday and weekend requests are processed on Monday.
              </p>
            </div>
          }
          disabled={!formData.amount || parseFloat(formData.amount || 0) <= 0 || parseFloat(formData.amount || 0) > parseFloat(walletAccount?.balance_naira || 0) || !formData.remark}
        />
      </Modal>
    </Column>
  )
}

export default Dashboard;
